"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var actions_1 = __importDefault(require("../../../../actions"));
var validation_1 = require("../../../../../../shared/util/validation");
function useShortLink(shortLink) {
    var urls = react_redux_1.useSelector(function (state) { return state.user.urls; });
    var urlState = urls.filter(function (url) { return url.shortUrl === shortLink; })[0];
    var isUploading = react_redux_1.useSelector(function (state) { return state.user.isUploading; });
    var dispatch = react_redux_1.useDispatch();
    var dispatchOptions = {
        toggleStatus: function () {
            return dispatch(actions_1.default.toggleUrlState(shortLink, urlState.state));
        },
        setEditLongUrl: function (editedUrl) {
            dispatch(actions_1.default.setEditedLongUrl(shortLink, editedUrl));
        },
        setEditDescription: function (editedDesc) {
            dispatch(actions_1.default.setEditedDescription(shortLink, editedDesc));
        },
        setEditContactEmail: function (editedContactEmail) {
            dispatch(actions_1.default.setEditedContactEmail(shortLink, editedContactEmail));
        },
        applyEditLongUrl: function (editedUrl) {
            if (!validation_1.isValidLongUrl(editedUrl)) {
                throw new Error('Attempt to save an invalid long url.');
            }
            dispatch(actions_1.default.updateLongUrl(shortLink, editedUrl));
        },
        applyEditInformation: function () {
            dispatch(actions_1.default.updateUrlInformation(shortLink));
        },
        applyNewOwner: function (newOwner, onSuccess) {
            dispatch(actions_1.default.transferOwnership(shortLink, newOwner, onSuccess));
        },
        applyEditTags: function (editedTags) {
            dispatch(actions_1.default.updateTags(shortLink, editedTags));
        },
        replaceFile: function (newFile, onError) {
            if (!newFile) {
                return;
            }
            dispatch(actions_1.default.replaceFile(shortLink, newFile, onError));
        },
    };
    return {
        shortLinkState: shortLink ? urlState : undefined,
        shortLinkDispatch: shortLink ? dispatchOptions : undefined,
        isUploading: isUploading,
    };
}
exports.default = useShortLink;
